"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var QuoteReviewModal_1 = __importDefault(require("~/components/modal/QuoteReviewModal"));
var quote_review_modal_store_1 = __importDefault(require("~/stores/modal/quote_review_modal_store"));
var QuoteLink = (0, mobx_react_1.observer)(function (props) {
    var modalStore = (0, mobx_react_1.useLocalStore)(function () { return new quote_review_modal_store_1.default(props); });
    var handleClick = function () { modalStore.open(); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: props.className, onClick: handleClick }, "\u30AF\u30C1\u30B3\u30DF\u3092\u5F15\u7528"),
        react_1.default.createElement(QuoteReviewModal_1.default, { store: modalStore })));
});
exports.default = QuoteLink;
